<template>
    <div class="Details">
    <section>
        <div class="columns">
            <div class="column is-12">
                <!-- <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false">
                </b-loading> -->
                
                <!-- <b-notification :closable="false" class="box" type="is-success" v-if="currentOrg">
                <span class=" is-9 has-text-centered has-text-weight-bold">
                    If you require additional credits, please send us an email at help@metatext.io. We'll be happy to assist you with obtaining the extra credits you need to continue your tasks. We're here to support you every step of the way.
                </span>
                </b-notification> -->
                
                <!-- <b-message class="box" type="is-success" has-icon v-if="(currentOrg['plan']['name'] == 'Pro')?(currentOrg['plan']['name'] == 'Pro')?true:false:false">
                <p class="title is-5 has-text-success-dark">Fantastic! Thank you for choosing our PRO plan.</p>
                
                <p class="subtitle is-6 has-text-success-dark">
                    We're confident that our services will meet your needs. As a PRO subscriber, your account was upgraded with more resources, you'll also receive SLA and support to ensure that you have a smooth experience. If you have any questions or concerns, please don't hesitate to reach out at help@metatext.io or Chat.
                </p>
                <p class="subtitle is-6 has-text-success-dark">
                    Thank you for choosing us, and we look forward to helping you achieve your goals!
                </p>
                <p class="subtitle is-6 has-text-success-dark">Here are some suggestions you can start using the platform right away.</p>
                <p class="subtitle is-6 has-text-success-dark">
                    <ul>
                        <li>Start with a <a href="https://metatext.io/documentation" target="_blank">Quickstart</a> tutorial</li>
                        <li>Check out our <a href="https://metatext.io/documentation" target="_blank">Documentation</a></li>
                        <li>Join our <a href="https://discord.gg/8qZ3Y4" target="_blank">Discord</a> community</li>
                        <li>Check out our <a href="https://metatext.io/blog" target="_blank">Blog</a></li>
                    </ul>
                </p>
                <p class="subtitle is-6 has-text-success-dark">
                Join our 1:1 AI/NLP Workshop with one of our AI expert, please schedule here <a href="https://calendly.com/rafael-sandroni/15min">Calendar</a>.
                </p>
                <p class="subtitle is-6 has-text-success-dark">
                
                </p>
            </b-message> -->

            
                
            <!-- <Pricing :currentUser="currentOrg" :onboarding="false"/> -->


            <br>
            
                
        </div>
        
        </div>
    </section>

    </div>
</template>
<script>
import { StripeCheckout } from '@vue-stripe/vue-stripe';
import Pricing from '@/components/Pricing.vue'
import plans from './../../plans'

export default {
     props: ["currentOrg", "datasetsTotal", "modelsTotal", "stepId", "paymentType", "sessionState"],
     name: "Settings",
     data: function() {
        // this.publishableKey = 'pk_test_51I1WaoFB4mfNEXuj0zBEfNmL9dMxXtVwyFP9gxNKvf1RNdQ4xmjlkZbpJ53JeaUQivOkwPDHWmRZHkZ4FUBRQeBN00OdMzR8q8'
        // this.secret = "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"
        this.publishableKey = 'pk_live_51I1WaoFB4mfNEXujvIThHMraKyBbbQn4PFoVDmf2RqwFE7koDDImJxyOXvAdssBZuTCxhn5EK3mPr4WXV0k5BZdf00rjhNTwrk'
        this.secret = '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'
    return {
        all_users_api_key: 'Z0CDIgI42M5hggX0bpBB61UZswN4NiHNaqqsFIWd',
        isLoading: true,
        canceled: false,
        successed: false,
        selectedPlan: plans.pro,
        successURLStarter: 'http://app.metatext.ai/account/checkout/stripe/success?session_id={CHECKOUT_SESSION_ID}&plan=starter',
        successURLPro: 'http://app.metatext.ai/account/checkout/stripe/success?session_id={CHECKOUT_SESSION_ID}&plan=pro',
        cancelURL: 'http://app.metatext.ai/account/checkout/stripe/cancel',
    }},
    components: {
      StripeCheckout,
      Pricing
    },
    computed: {
        checkoutParams() {
            return this.$store.state.checkout;
        },
    },
    methods: {
        submit () {
            this.$refs.checkoutRef.redirectToCheckout();
        },
        success(){
            this.isLoading = true
            console.log("success")
            this.$buefy.toast.open({
                    message: `Processing your payment...`
            })

            let checkoutParams = this.$route.query
            const method = (this.paymentType ?  this.paymentType : this.$route.params.paymentType)
            const license = checkoutParams.l;
            const selectedPlan = checkoutParams.p;
            const creditsQuota = checkoutParams.c;
            const isOnboarding = checkoutParams.o;
            const sessionId = this.$route.query.s ? this.$route.query.s : `stripe-${this.$firebase.auth().currentUser.uid}`;
            this.$router.replace({'query': null});
            if (selectedPlan == undefined){
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Please select a plan.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                this.isLoading = false
                this.$router.push({ name: 'D', params: { start: 'pricing' } })
            }

            let plan = plans[selectedPlan]
            let appsumo = license == 'lifetime' ? true : false
            
            if (appsumo){
                plan.name = 'AppSumo'
            }
            
            const toUpdate = {
                userId: this.$firebase.auth().currentUser.uid,
                update: {
                    payment: {
                        active: true,
                        sessionId: sessionId,
                        method: method,
                        license: license,
                        plan: selectedPlan,
                        success: true,
                        date: new Date()
                    },
                    plan: plan,
                    creditsQuota: creditsQuota,
                    creditsRemaining: creditsQuota,
                }
            }

            this.$store.dispatch("updatePayments", 
                toUpdate
            );

            const toUpdateUsagePlan = {
                userId: this.$firebase.auth().currentUser.uid,
                newPlan: selectedPlan,
                newCreditsQuota: creditsQuota
            }

            this.$store.dispatch("changeAPIUsagePlan", 
                toUpdateUsagePlan
            );

            this.successed = true
            this.isLoading = false
            this.$buefy.toast.open({
                message: `Payment processed!`
            })

            this.$store.dispatch("currentUser")
            // update api-gateway

            this.$confetti.start();
            
            setTimeout(() => 1000);

            if (isOnboarding){
                this.$router.push({ name: 'Dashboard', params: { start: 'start', stepId: 'classification' } })
            } else {
                this.$router.push({ name: 'Account', params: { stepId: 'usage' } })
            }
            
            this.$buefy.dialog.alert({
                title: 'Thank you!',
                message: 'You have subscribed to the '+plan.name+' plan.',
                type: 'is-primary',
                hasIcon: false,
                icon: 'times-circle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true,
                onConfirm: () => {
                    this.$router.go()
                    setTimeout(() => {
                        this.$confetti.stop();
                    }, 1300);

                    
                }
            })

            
            
        },
        cancel(){
            // Pop-up message
            this.$store.dispatch("sendEmailNotificationAdmin", 
                {
                    title: `Someone tried checkout page for ${planName} plan`,
                    data: {
                        plan: planName,
                        user: this.currentOrg,
                        onboarding: this.$route.query.o
                    }
                }
            );

            if (this.$route.query.o == 'true' || this.$route.query.o == true){
                this.$router.push({ name: 'Onboarding' })
            } else {
                this.$router.push({ name: 'Account', params: { stepId: 'usage' } })
            }

            this.canceled = true
            this.$buefy.dialog.alert({
                title: 'Something was wrong!',
                message: 'You canceled. Something that we can help? Write a line at help@metatext.io',
                type: 'is-white',
                hasIcon: false,
                icon: 'times-circle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true
            })
        }
    },
    mounted(){
        this.$store.dispatch("currentUser")
    },
    created(){
        this.$store.dispatch("currentUser")

        if(this.$route.params.action == 'success'){
            this.success()
        } else if(this.$route.params.action == 'cancel'){
            this.cancel()
        }
    }
   };
</script>